import { COMPONENT_IDS } from "../storage2ComponentIDs";
class CalculateCrossBraceComponent {
    constructor(calculate) {
        this.calculate = calculate;
        this.typeId = CalculateCrossBraceComponent.id;
        this.doStoreInSnapshot = false;
        this.serializable = false;
    }
    eq(other) {
        return other.calculate === this.calculate;
    }
}
CalculateCrossBraceComponent.id = COMPONENT_IDS.CALCULATE_CROSS_BRACE;
export default CalculateCrossBraceComponent;
